import React from "react";
import ad from "../assets/images/Netflix3.png";

const Netflix =() =>{

    return(
        <div className="Netflix-ad" >
       <img src={ad} className="img-fluid netflix-img" alt="netflix-ad"/>
        </div>
    )
}

export default Netflix;